module.exports = __webpack_public_path__ + "static/media/md-arrow-dropright-circle.c3db1189.svg";